// extracted by mini-css-extract-plugin
export default {"cls1":"VeloGrid_cls1__2byIU","cls2":"VeloGrid_cls2__ifzyV VeloGrid_cls1__2byIU","compact":"VeloGrid_compact__1R6Q3"};